import { render, staticRenderFns } from "./ProgramSelection.vue?vue&type=template&id=39f2587b&scoped=true"
import script from "./ProgramSelection.vue?vue&type=script&lang=js"
export * from "./ProgramSelection.vue?vue&type=script&lang=js"
import style0 from "./ProgramSelection.vue?vue&type=style&index=0&id=39f2587b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f2587b",
  null
  
)

export default component.exports